import dayjs from "dayjs"
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import zh from 'dayjs/locale/zh-cn';

dayjs.locale(zh);
dayjs.extend(customParseFormat)
dayjs.extend(relativeTime);

export { dayjs }